export const maxUploadFiles = process.env.VUE_APP_MAX_UPLOAD_FOLIOS;
export const firstLimitDaysFolio = 30;
export const secondLimitDaysFolio = 60;
export const maxQueryCertificates = 5;
export const apiValidateCertificate = 'https://api.certificadotradicionylibertad.com/v1/registration';
export const maxZipPdfs = process.env.VUE_APP_MAX_ZIP_PDFS;
